module.exports = __webpack_public_path__ + "static/tokens-7a4d9133d90ff7735901340cc8f41e29.jpeg";